import React from 'react';
import PropTypes from 'prop-types';

import './IOSLoader.scss';

const IOSLoader = ({ size }) => (
  <div
    className="spinner"
    style={{
      width: `${size}px`,
      height: `${size}px`,
    }}
  >
    <div className="bar1" />
    <div className="bar2" />
    <div className="bar3" />
    <div className="bar4" />
    <div className="bar5" />
    <div className="bar6" />
    <div className="bar7" />
    <div className="bar8" />
    <div className="bar9" />
    <div className="bar10" />
    <div className="bar11" />
    <div className="bar12" />
  </div>
);

IOSLoader.propTypes = {
  size: PropTypes.number,
};
IOSLoader.defaultProps = {
  size: 40,
};

export default IOSLoader;
